import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ISnackMessage, LoadingSnackbarService } from '../services/loading-snackbar.service';

@Component({
  selector: 'app-loading-snackbar',
  templateUrl: './loading-snackbar.component.html',
  styleUrls: ['./loading-snackbar.component.scss'],
  imports: [
    NgClass,
    NgForOf,
    NgIf
  ],
  animations: [
    trigger('transitionNewMessageInOut', [
      transition(':enter', [
        style({ height: '0' }),
        animate('0.2s ease-out', style({ height: '25px' })),
      ]),
      transition(':leave', [
        style({ height: '25px' }),
        animate('0.2s 2s ease-out', style({ height: '0' })),
      ]),
    ]),
  ]
})

export class LoadingSnackbarComponent {

  messages: ISnackMessage[] = [];

  constructor(private loadingSnackbarService: LoadingSnackbarService) {
    this.loadingSnackbarService.messages$.subscribe(messages => {
      this.messages = messages;
    });
  }

}
